import React from 'react';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { isNullUndefined } from '../../../../../../common/Helpers';

function ELEMENT_CONTRACT_MOTNHS(props) {

  const { 
      inputParam_Item = null,
      inputParam_FontSize = "16px",
      inputParam_ContainerComponent = null
    } = props;
    

    return (
      <>
        {
          inputParam_Item &&
          <Card className="h-100 p-0 m-0"
            data-container-id={!isNullUndefined(inputParam_ContainerComponent) ? inputParam_ContainerComponent.containerId : ''}
            data-component-id={!isNullUndefined(inputParam_ContainerComponent) ? inputParam_ContainerComponent.id : ''}
          >
              <div className="h-50 border-bottom" style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
                    { inputParam_Item.title }
              </div>
              <Card.Body className='h-50 p-0 m-0 pt-1 text-center rounded-top'>
                <b style={{fontSize: inputParam_FontSize}}>{ `${inputParam_Item.value} ${inputParam_Item.um}` }</b>
              </Card.Body>
          </Card>
        }
      </>
    );
}

ELEMENT_CONTRACT_MOTNHS.propTypes = {
  inputParam_Item: PropTypes.object.isRequired,
  inputParam_FontSize: PropTypes.string,
};

export default ELEMENT_CONTRACT_MOTNHS;